import angular from 'angular';
import angularCookies from 'angular-cookies';
import uiRouter from 'angular-ui-router';
import ngAdmin from 'ng-admin';
import AppComponent from './app.component'; //noqa
import jwt_decode from 'jwt-decode'

import {getRoleEntity} from './helpers';
import moment from "moment";
import 'normalize.css';
import {initPerson, initProfile, initSubscription} from './entities/common';
import {initStream, initPublisher, initStoryBlacklist} from './entities/content';
import {initReport, initReportUser, initReportEmail} from './entities/notification';
import {initRoles} from './entities/security';
import ezyImpersonateButton from './directives/ezyImpersonateButton';
import ezyManageSubscription from './directives/ezyManageSubscription';
import ezyBoolTimestampField from './directives/ezyBoolTimestampField';
import ezyDisableStoryButton from './directives/ezyDisableStoryButton';
import ezyLogsTable from "./directives/ezyLogsTable";

// ------------ entities ------------------

// HTML
import dashboardTemplate from './dashboard.html';

let initSubscriptionUser = (nga) => {
  let subscription = nga.entity('user_subscription');
  let subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription'))
    .targetField(nga.field('name')).remoteComplete(true, {
      searchQuery: (search) => {
        return {name__icontains: search}
      }
    });
  let userField = nga.field('user_id', 'reference').label('Email').targetEntity(nga.entity('person'))
    .targetField(nga.field('email')).remoteComplete(true, {
      searchQuery: (search) => {
        return {email__icontains: search}
      }
    });
  subscription.listView().title('Subscription user list').fields([
    nga.field('id'),
    subscriptionField,
    userField,
  ]).filters([
    subscriptionField.pinned(true),
    userField.pinned(true)
  ]).actions(['create', 'filter']);

  subscription.creationView().title('Create subscription').fields([
    subscriptionField,
    userField,
    nga.field('frontend_settings', 'json')
  ]);
  subscription.editionView().title('Edit subscription').fields(subscription.creationView().fields()).actions(['list']);

  return subscription;
};

let initStreamFeatures = (nga) => {
  let streamFeature = nga.entity('stream_feature');
  let streamField = nga.field('stream_id', 'reference').label('Stream').targetEntity(nga.entity('stream'))
    .targetField(nga.field('name')).remoteComplete(true, {
      searchQuery: (search) => {
        return {name__icontains: search}
      }
    });
  let subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription'))
    .targetField(nga.field('name')).remoteComplete(true, {
      searchQuery: (search) => {
        return {name__icontains: search}
      }
    });
  streamFeature.listView().title('Stream features').fields([
    nga.field('id'),
    streamField,
    subscriptionField,
    nga.field('feature_type')
  ]).filters([
    streamField.pinned(true),
    subscriptionField.pinned(true)
  ]).actions(['create', 'filter']);

  streamFeature.creationView().title('Create stream feature').fields([
    streamField,
    subscriptionField,
    nga.field('feature_type').defaultValue(1)
  ]);
  streamFeature.editionView().title('Edit stream feature').fields(streamFeature.creationView().fields()).actions(['list']);

  return streamFeature;
};

let initPostingPolicy = (nga) => {
  let entity = nga.entity('posting_policy').identifier(nga.field('stream_id')).label('Traffic light policies');
  let streamField = nga.field('stream_id', 'reference').label('Stream').targetEntity(nga.entity('stream'))
    .targetField(nga.field('name')).remoteComplete(true, {
      searchQuery: (search) => {
        return {name__icontains: search}
      }
    });
  entity.listView().title('Traffic light policies').fields([
    nga.field('stream_id'),
    streamField,
    nga.field('speed_threshold'),
    nga.field('wait_time')
  ]).filters([
    streamField.pinned(true),
  ]).actions(['create', 'filter']).sortField('stream_id');

  entity.creationView().title('Create posting policy').fields([
    streamField,
    nga.field('speed_threshold'),
    nga.field('wait_time')
  ]);
  entity.editionView().title('Edit posting policy').fields(entity.creationView().fields()).actions(['list']);

  return entity;
};


let initFilter = (nga) => {
  let subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription'))
    .targetField(nga.field('name')).remoteComplete(true, {
      searchQuery: (search) => {
        return {name__icontains: search}
      }
    });
  let entity = nga.entity('filter');
  entity.listView().title('Filter list').fields([
    nga.field('id').isDetailLink(true),
    nga.field('filter_name', 'string'),
    nga.field('whitelist_streams', 'reference_many').targetEntity(nga.entity('stream'))
      .targetField(nga.field('name')),
    nga.field('user_id'),
    subscriptionField
  ]).filters([
    subscriptionField
  ]).actions(['create', 'filter']);

  entity.showView().title('Filter info').fields([
    nga.field('id').isDetailLink(true),
    nga.field('filter_name', 'string'),
    nga.field('whitelist_streams', 'reference_many').targetEntity(nga.entity('stream'))
      .targetField(nga.field('name')),
    nga.field('user_id'),
    subscriptionField
  ]);

  return entity;
};


function getJWTToken() {
  const cookieMatch = document.cookie.match(/EzyInsights=(.*?)(?:;|$)/);
  if (cookieMatch)
    return cookieMatch[1];
}

let ezyToken = null;

let AdminModule = angular.module('app', [
  'ng-admin', 'ngCookies',
])
  .config([
    'NgAdminConfigurationProvider', 'FieldViewConfigurationProvider', 'RestangularProvider',
    (nga, fvp, rp) => {
      ezyToken = getJWTToken();
      if (ezyToken) {
        const jwt = jwt_decode(ezyToken);
        if (jwt.exp < Date.parse(new Date()) / 1000) {
          location.href = '/login.html';
        }
        rp.setDefaultHeaders({'X-EzyInsights': ezyToken});
      } else
        location.href = '/login.html';

      rp.addFullRequestInterceptor(function (response, deferred, responseHandler) {
        const cookie = getJWTToken();
        const jwt = jwt_decode(cookie);
        if (jwt.exp < Date.parse(new Date()) / 1000) {
          location.href = '/login.html';
        }
        ezyToken = cookie;
      });


      // Fields
      nga.registerFieldType('unixtime', require('./fields/unixtime'));
      nga.registerFieldType('datedict', require('./fields/datedict'));
      nga.registerFieldType('bool_timestamp', require('./fields/bool_timestamp'));
      nga.registerFieldType('countries', require('./fields/countries'));
      nga.registerFieldType('country', require('./fields/country'));
      nga.registerFieldType('language', require('./fields/languages'));
      nga.registerFieldType('category', require('./fields/categories'));
      nga.registerFieldType('timezone', require('./fields/timezones'));

      fvp.registerFieldView('unixtime', require('./fieldView/UnixTimeFieldView'));
      fvp.registerFieldView('datedict', require('./fieldView/DateDictFieldView'));
      fvp.registerFieldView('bool_timestamp', require('./fieldView/BoolTimestampFieldView'));

      const admin = nga.application('BOA')
        .baseApiUrl(API_ROOT + "/api/");

      admin.addEntity(initPublisher(nga));
      admin.addEntity(initStream(nga));
      admin.addEntity(initPostingPolicy(nga));
      admin.addEntity(initStoryBlacklist(nga));
      admin.addEntity(initStreamFeatures(nga));

      admin.addEntity(initSubscription(nga));
      admin.addEntity(initPerson(nga));
      admin.addEntity(initProfile(nga));
      admin.addEntity(initRoles(nga));
      admin.addEntity(initSubscriptionUser(nga));
      admin.addEntity(initFilter(nga));
      admin.addEntity(initReport(nga));
      admin.addEntity(initReportUser(nga));
      admin.addEntity(initReportEmail(nga));
      admin.menu(nga.menu()
        .addChild(nga.menu().template(`
        <a href="http://boav2.ezyinsights.com" target="_blank">
            <span class="glyphicon glyphicon-new-window"></span>
            Content sources
        </a>`
        ))
        .addChild(nga.menu().title('Content sources')
          .addChild(nga.menu(nga.entity('posting_policy')))
          .addChild(nga.menu(nga.entity('stream_feature')))
        )
        .addChild(nga.menu().title('Data')
          .addChild(nga.menu(nga.entity('story_blacklist')))
        )
        .addChild(nga.menu().title('Accounts')
          .addChild(nga.menu(nga.entity('person')).title('User'))
          .addChild(nga.menu(nga.entity('profile')))
          .addChild(nga.menu(nga.entity('subscription')))
          .addChild(nga.menu(nga.entity('user_subscription')))
          .addChild(nga.menu(nga.entity('roles')))
          .addChild(nga.menu(nga.entity('notification_report')).title('Email report'))
          .addChild(nga.menu(nga.entity('notification_report_user')).title('Email report user'))
          .addChild(nga.menu(nga.entity('notification_report_email')).title('Email report email'))
        )
        .addChild(nga.menu(nga.entity('filter'))),
      );

      admin.dashboard(nga.dashboard().template(dashboardTemplate));
      nga.configure(admin);
    }]);

AdminModule.controller('SearchController', ['$scope', '$http', '$location',
  function ($scope, $http, $location) {
    const searchTerm = $location.search()['search-term'];
    $scope.search_term = searchTerm;
    $scope.searchStatus = null;
    $scope.allowSearch = true;

    $scope.search = function () {
      const url = 'https://boa.ezyinsights.com/api/search/' + $scope.search_term;
      $scope.data = null;
      $scope.results = null;
      $scope.searchStatus = 'Searching please wait...';
      $scope.allowSearch = false;
      $http.get(url)
        .then(function onSuccess(response) {
          const data = response.data;
          $scope.data = data;
          $scope.logs = data.logs;
          $scope.canonical = data.canonical;
          $scope.publisher = data.publisher;
          $scope.realtime = data.realtime;
          $scope.sources = Object.keys(data.sources)
            .reduce((o, k) => {
              let v  = data.sources[k];
              v['message_id'] = k;
              v['created_at'] = Math.min(v.html ? v.html.created_at: Math.MAX_SAFE_INTEGER, v.json ? v.json.created_at: Math.MAX_SAFE_INTEGER);
              o.push(v);
              return o;
            }, []);
          $scope.results = Object.keys(data)
            .filter(k => !['logs'].includes(k))
            .reduce((o, k) => {
              o[k] = data[k];
              return o;
            }, {});
          $scope.searchStatus = 'Search results for "' + $scope.search_term + '":';
          $scope.allowSearch = true;
        }, function onError(response) {
          $scope.searchStatus = 'Search failed please try again!';
          $scope.allowSearch = true;
          console.error(response);
        });
    };

    if (searchTerm) {
      $scope.search();
    }

    $scope.copyToClipboard = function () {
      const textArea = document.createElement("textarea");

      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.width = '2em';
      textArea.style.height = '2em';
      textArea.style.padding = '0';
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';
      textArea.style.background = 'transparent';

      textArea.value = JSON.stringify($scope.data);

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
      } catch (err) {
        console.log('Oops, unable to copy');
      }

      document.body.removeChild(textArea);
    }
}]);

AdminModule.filter('timeAgo', ['$interval', function ($interval) {
  // trigger digest every 60 seconds
  $interval(function () {
  }, 60000);

  function fromNowFilter(time) {
    return moment(time).fromNow();
  }

  fromNowFilter.$stateful = true;
  return fromNowFilter;
}]);

AdminModule.filter('localTime', function () {
  function fromNowFilter(isoTime) {
    return moment.utc(isoTime).local().format('YYYY-MM-DD HH:mm:ss.SSS Z');
  }
  return fromNowFilter;
});

AdminModule.directive('ezyImpersonateButton', ezyImpersonateButton);
AdminModule.directive('ezyManageSubscription', ezyManageSubscription);
AdminModule.directive('ezyBoolTimestampField', ezyBoolTimestampField);
AdminModule.directive('ezyDisableStoryButton', ezyDisableStoryButton);
AdminModule.directive('ezyLogsTable', ezyLogsTable);



// WEBPACK FOOTER //
// ./client/app/app.js